'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import PropTypes from 'prop-types';
import { cloneElement, Children, Component } from 'react';
import UILayer from '../layer/UILayer';
import { isPageInKeyboardMode } from '../listeners/focusStylesListener';
import { warnIfFragment } from '../utils/devWarnings';

// Based on https://github.com/twbs/bootstrap/blob/v3.3.6/dist/js/bootstrap.js
import { jsx as _jsx } from "react/jsx-runtime";
function measureScrollbar() {
  const scrollDiv = document.createElement('div');
  scrollDiv.className = 'uiFullScreen-scrollbar-measure';
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
export default class UIFullScreen extends Component {
  constructor(props) {
    super(props);
    this.handleCloseComplete = () => {
      if (this._lastFocus) {
        if (isPageInKeyboardMode()) {
          this._lastFocus.focus();
        }
        this._lastFocus = null;
      }
      if (this.constructor.layerCount === 0) {
        this.restoreBackgroundScrolling();
      }
    };
    this._lastFocus = document.activeElement;
  }
  componentDidMount() {
    this.constructor.layerCount += 1;
    if (this.constructor.layerCount === 1) {
      this.disableBackgroundScrolling();
    }
  }
  componentWillUnmount() {
    this.constructor.layerCount -= 1;
  }
  disableBackgroundScrolling() {
    this.addFauxScrollbar();
    [document.documentElement, document.body].forEach(el => el.classList && el.classList.add(this.constructor.NO_SCROLL_CLASS));
  }
  restoreBackgroundScrolling() {
    this.removeFauxScrollbar();
    [document.documentElement, document.body].forEach(el => el.classList && el.classList.remove(this.constructor.NO_SCROLL_CLASS));
  }
  addFauxScrollbar() {
    const bodyHasScrollbar = document.body.clientWidth < window.innerWidth;
    if (bodyHasScrollbar) {
      const scrollbarWidth = `${measureScrollbar()}px`;

      // To avoid changing the body width when we disable scrollbar, we replace
      // the scrollbar with padding of equal width.
      this.constructor.originalBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollbarWidth;
    }
  }
  removeFauxScrollbar() {
    document.body.style.paddingRight = this.constructor.originalBodyPaddingRight;
  }
  render() {
    const _this$props = this.props,
      {
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    warnIfFragment(children, UIFullScreen.displayName);
    return /*#__PURE__*/_jsx(UILayer, Object.assign({}, rest, {
      onCloseComplete: this.handleCloseComplete,
      children: /*#__PURE__*/cloneElement(Children.only(children), {
        open: true
      })
    }));
  }
}
UIFullScreen.layerCount = 0;
UIFullScreen.NO_SCROLL_CLASS = 'uiFullScreenBackground';
UIFullScreen.originalBodyPaddingRight = '';
UIFullScreen.propTypes = {
  children: PropTypes.element.isRequired,
  rootNode: UILayer.propTypes.rootNode,
  Transition: PropTypes.elementType
};
UIFullScreen.displayName = 'UIFullScreen';